import Pattern from "@/assets/svg/adcelerate/pattern.svg";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Button from "../ui/button";

export default function AdceCTA() {
  return (
    <div className="bg-black relative overflow-hidden pb-52 lg:pb-0 4xl:max-w-[100rem] 4xl:mx-auto">
      <div className="p-10 lg:p-20">
        <div className="lg:w-1/2 space-y-8 text-center lg:text-left">
          <p className="text-white">Get on board</p>
          <h1 className="adce-hero text-white font-bold text-4xl lg:text-6xl">
            Accelerate Your Growth with{" "}
            <span className="text-primary">ADCELERATE</span>
          </h1>
          <p className="text-white">
            Adcelerate connects your content to new platforms, advertisers, and
            audiences — without additional effort on your part. Expand your
            reach, unlock new revenue streams, and stay ahead in the creator
            economy.
          </p>
          <Link to="/esign" className="block">
            <Button className="group relative rounded-md shadow bg-primary text-white py-6 w-40 text-base items-center justify-center gap-2 overflow-hidden">
              <span className="transform transition-transform duration-300 group-hover:translate-x-5">
                Get Started
              </span>
              <ArrowRight className="transform transition-transform duration-300 group-hover:-translate-x-[95px]" />
            </Button>
          </Link>
          <p className="text-gray-500 text-lg">Trusted by 3,500+ creators</p>
        </div>
      </div>
      <div className="absolute top-[500px] md:top-80 -right-0 md:right-0 lg:-right-52 xl:-right-20 lg:top-1/2 lg:-translate-y-1/2 max-w-[800px] z-0">
        <img src={Pattern} className="animate-spin-slow" alt="Pattern" />
      </div>
    </div>
  );
}
